import React from 'react';
import { Tooltip } from 'antd';

import { CardContainer, SummaryLabel, TooltipIcon } from './InfoCard.styles';

const InfoCard = ({ title, children, tipsDescription }) => {
  return (
    <CardContainer>
      <SummaryLabel>
        {title}{' '}
        {!!tipsDescription && (
          <Tooltip placement="topLeft" title={tipsDescription}>
            <TooltipIcon />
          </Tooltip>
        )}
      </SummaryLabel>
      {children}
    </CardContainer>
  );
};

export default InfoCard;
